import {Component, Inject, OnInit} from 'ng-metadata/core';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import {MediaQueries} from "../../infra/mediaQueries.service";
import {getAttributesMap, getRtlLanguages, getVid} from '../../appConfig/appConfigForward';
import {VoiceSearchToastService} from './voiceSearchToast.service';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';

let annyang = require('annyang');
const _sortBy = require('lodash/sortBy');

@Component({
    'selector': 'prm-voice-search-toast', 
    templateUrl: 'components/search/searchBar/voice-search-toast.html'
})

export class PrmVoiceSearchToast implements OnInit{
    private showVoiceSearchLanguages = true;
    private isVoiceSearchToastOpen = true;
    private languages:string[];
    private voiceSearchDidntGetItTimout1 = 10000;
    private voiceSearchDidntGetItTimout2 = 20000;
    private voiceSearchDidntGetItCheckTimout = 30000;
    private voiceSearchDisplayTimout = 3000;
    private voiceSearchListeningTranslation = $translate.instant('nui.voice_listening');
    private voiceSearchDidntGetItTranslation = $translate.instant('nui.voice_didntGetIt');
    private voiceSearchDidntGetItCheckTranslation = $translate.instant('nui.voice_didntGetItCheck');
    private attributesMap = getAttributesMap();
    private INTERFACE_LANGUAGE_CODE_PREFIX = 'mypref.language.option.';
    private VOICE_API_LANGUAGE_CODE_PREFIX = 'voiceSearch.';
    
    
   
    constructor(private primolyticsService: PrimolyticsService,
                @Inject('$window') private $window: ng.IWindowService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$timeout') private $timeout: angular.ITimeoutService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('featuredActionsIcons') private actionsIcons,
                private configurationUtil : ConfigurationUtil,
                private mappingTablesCache: MappingTablesCache,
                private voiceSearchToastService: VoiceSearchToastService,
                private mediaQueries: MediaQueries) {
        this.$timeout(()=> {
            if(this.languages.length > 1){
                document.querySelector('#voiceSearchLanguageButton').focus();
            }else{
                document.querySelector('#voiceSearchCloseButton').focus();
            }
        }, 300);

        this.languages = this.getVoiceSearchLanguageList();
        if(!this.voiceSearchToastService.lastVoiceSearchLanguage)
            this.initDefaultSearchLang();
        document.getElementById('voiceSearchToast').addEventListener('keydown', function(event) { 
            if (event.key === "Escape" || event.key === "backspace") {
                this.onDismiss(); // to close toast on escape button 
            }
        }.bind(this), false);
        window.onpopstate = () => {
            window.onpopstate = undefined;
            this.onDismiss();
        };
        this.showVoiceSearchLanguages = (this.languages.length > 1) ? true : false; 
        this.startTimers();
    }

    ngOnInit() {
    }

    public checkInclude(languageCheck) {
        let langList = [...this.languages];
        if(!this.configurationUtil.isSuprima())
            langList = langList.map(lang => lang.replace("-", "_"));
        return langList.indexOf(languageCheck) > -1;
    }


    public initDefaultSearchLang() {
        if(this.configurationUtil.isSuprima()) {
            const defualtLang = this.INTERFACE_LANGUAGE_CODE_PREFIX + this.attributesMap.interfaceLanguage;
            this.voiceSearchToastService.lastVoiceSearchLanguage = this.checkInclude(defualtLang) ? defualtLang : this.languages[0]
        }
        else {
            const defualtLang = this.VOICE_API_LANGUAGE_CODE_PREFIX + this.attributesMap.interfaceLanguage;
            let getDefualtLang = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VOICE_SEARCH_LANGUAGES, {source1: this.attributesMap.interfaceLanguage});
            const isInclude = getDefualtLang && getDefualtLang.length > 0 && getDefualtLang[0].source2 && this.checkInclude(defualtLang);
            this.voiceSearchToastService.lastVoiceSearchLanguage = isInclude ? this.VOICE_API_LANGUAGE_CODE_PREFIX + getDefualtLang[0].source2 : this.languages[0];
        }
        this.changeVoiceSearchLanguage();
    }


    public onDismiss() {
        this.isVoiceSearchToastOpen = false;
        this.$timeout(()=> {
            document.querySelector('#voiceSearchButton').focus();
            this.voiceSearchExitBeacon();
            this.voiceSearchToastService.onDismiss();
        }, 100);
    }
    
    public changeVoiceSearchLanguage() {
        if (annyang) {
            // takes the last part in the language
            let apiVoiceSearchLanguage = this.voiceSearchLanguage.split('.').pop();
            if(this.configurationUtil.isSuprima()){
                // convert Primo language code to voice API code
                let apiLanguageCodesList = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VOICE_SEARCH_LANGUAGES, {source1: apiVoiceSearchLanguage});
                if(apiLanguageCodesList && apiLanguageCodesList.length > 0 && apiLanguageCodesList[0].source2){
                  apiVoiceSearchLanguage  = apiLanguageCodesList[0].source2;
                }
            }
            annyang.abort();
            annyang.setLanguage(apiVoiceSearchLanguage);// Change language the annyang
            annyang.start();
        }
    }

    public getVoiceSearchLanguageList() {
        let voiceSearchLanguageList=[];
        let voiceSearchActivatedLanguages = this.mappingTablesCache.getTable(this.mappingTablesCache.tables.VOICE_SEARCH_LANGUAGES_ACTIVATION);
        
        if(voiceSearchActivatedLanguages && voiceSearchActivatedLanguages.length > 0){ // use the languages activated in the "Voice Search Languages Activation" MT
            voiceSearchActivatedLanguages = _sortBy(voiceSearchActivatedLanguages, [function(voiceSearchActivatedLanguage) { return parseInt(voiceSearchActivatedLanguage.source2); }]); 
            voiceSearchLanguageList = voiceSearchActivatedLanguages.map((language)=>this.VOICE_API_LANGUAGE_CODE_PREFIX + language.target);
        }else{ // use interface languages
            let interfaceLanguageOptions = this.attributesMap.interfaceLanguageOptions.split(',');
            for(let interfaceLanguage of interfaceLanguageOptions) { // convert interface languages code to voice api code
                if(this.configurationUtil.isSuprima()){
                    voiceSearchLanguageList.push(this.INTERFACE_LANGUAGE_CODE_PREFIX + interfaceLanguage);
                }
                else{
                    // convert Primo language code to voice API code
                    let apiLanguageCodesList = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VOICE_SEARCH_LANGUAGES, {source1: interfaceLanguage});
                    if(apiLanguageCodesList && apiLanguageCodesList.length > 0 && apiLanguageCodesList[0].source2){
                        voiceSearchLanguageList.push(this.VOICE_API_LANGUAGE_CODE_PREFIX + apiLanguageCodesList[0].source2);
                    }
                }
            }
        }
        return voiceSearchLanguageList;
    }

    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }
    
    /**
     * Starts timers to change the voice Search Title, when the user doesn't speak
     */
    public startTimers() {
        
        this.voiceSearchToastService.voiceSearchTitle = this.voiceSearchListeningTranslation;            
        this.voiceSearchToastService.waitingVoiceSearchTimerDidntGetIt1 = this.$timeout(()=> {
            this.voiceSearchToastService.voiceSearchTitle = this.voiceSearchDidntGetItTranslation;
            this.voiceSearchDidntGetItBeacon();
            this.$timeout(()=> {
                this.voiceSearchToastService.voiceSearchTitle = this.voiceSearchListeningTranslation;
            }, this.voiceSearchDisplayTimout);
        }, this.voiceSearchDidntGetItTimout1);
        
        this.voiceSearchToastService.waitingVoiceSearchTimerDidntGetIt2 = this.$timeout(()=> {
            this.voiceSearchToastService.voiceSearchTitle = this.voiceSearchDidntGetItTranslation;
            this.voiceSearchDidntGetItBeacon();
            this.$timeout(()=> {
                this.voiceSearchToastService.voiceSearchTitle = this.voiceSearchListeningTranslation;
            }, this.voiceSearchDisplayTimout);
        }, this.voiceSearchDidntGetItTimout2);
        
        this.voiceSearchToastService.waitingVoiceSearchTimerDidntGetItCheck = this.$timeout(()=> {
            this.voiceSearchToastService.voiceSearchTitle = this.voiceSearchDidntGetItCheckTranslation;  
            this.voiceSearchDidntGetItCheckBeacon();
            this.isVoiceSearchToastOpen = false;
            this.$timeout(()=> {
                this.voiceSearchToastService.onDismiss();
            }, this.voiceSearchDisplayTimout);
        }, this.voiceSearchDidntGetItCheckTimout);
          
    }

    public keydownSupportVoiceSearchLanguage (e) {
        if (e.keyCode === 9) {
            e.preventDefault();
            return document.querySelector('#voiceSearchCloseButton').focus();
        }
    }

    public keydownSupportVoiceCloseButton (e) {
        if (e.keyCode === 9) {
            e.preventDefault();
            if(this.languages.length > 1){
                return document.querySelector('#voiceSearchLanguageButton').focus();
            }else{
                return document.querySelector('#voiceSearchCloseButton').focus();
            }
        }
    }
    
    get voiceSearchTitle() {
        return this.voiceSearchToastService.voiceSearchTitle;
    }
    
    set voiceSearchTitle(voiceSearchTitle) {
        this.voiceSearchToastService.voiceSearchTitle = voiceSearchTitle;
    }
    
    get voiceSearchLanguage() {
        return this.voiceSearchToastService.lastVoiceSearchLanguage;
    }
    
    set voiceSearchLanguage(voiceSearchLanguage) {
        this.voiceSearchToastService.lastVoiceSearchLanguage = voiceSearchLanguage;
    }
    
    @beacon({'p': 'voiceSearch', 'op': 'voiceSearchDidntGetIt'})
    public voiceSearchDidntGetItBeacon() {
    }
    
    @beacon({'p': 'voiceSearch', 'op': 'voiceSearchcheckMic'})
    public voiceSearchDidntGetItCheckBeacon() {
    }
    
    @beacon({'p': 'voiceSearch', 'op': 'voiceSearchExit'})
    public voiceSearchExitBeacon() {
    }
    
    @beacon({'p': 'voiceSearch', 'op': 'changeLanguage'})
    public voiceSearchChangeLanguageBeacon() {
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/voiceSearchToast.directive.ts